import { useAct } from 'DashboardUser/store'
import DashboardField from './DashboardField'

export default function DashboardTargetCard({ dashboardTargetId }) {
    const act = useAct()
    const dashboardTarget = useSel(s => s.dashboardTargets.entities[dashboardTargetId])
    const featuredFields = useSel(s => _.orderBy(s.dashboard.dashboardFields.filter(f => f.featuredColumn), 'digitOrder'));

    if (!dashboardTarget) return null

    return (
        <div className="dashboard-target-card">
            <div
                className="dashboard-target-card-header"
                onClick={() => act.local.upsert({ expandedDashboardTargetId: dashboardTargetId })}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        act.local.upsert({ expandedDashboardTargetId: dashboardTargetId })
                    }
                }}
            >
                <div className="dashboard-target-card-heading">
                    <div className="dashboard-target-card-title">
                        <span>{dashboardTarget.name}</span>
                    </div>
                    <div className="dashboard-target-card-subheader">
                        <span>{dashboardTarget.externalId}</span>
                    </div>
                </div>

                <div className="dashboard-target-card-action">
                    <SvgIconsEye />
                </div>
            </div>

            <div className="dashboard-target-card-body">
                {featuredFields.map(field => (
                    <div className="dashboard-target-card-body-row" key={field.id}>
                        <span className="dashboard-target-card-body-field-name">{field.name}</span>
                        <span className="dashboard-target-card-body-field-value">
                            <DashboardField field={field} dashboardTarget={dashboardTarget} />
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}